export const webIntercomProviderFactory = ({
  globWindow,
}: {
  globWindow: Window;
}) => {
  const boot = (obj: {
    hide_default_launcher: boolean;
    name?: string;
    facility?: string;
    email?: string;
    user_id?: string;
    [key: string]: string | number | boolean | undefined;
  }) => {
    globWindow.Intercom("boot", {
      custom_launcher_selector: "#my-custom-launcher",
      api_base: "https://api-iam.intercom.io",
      app_id: "crktr587",
      ...obj,
    });
  };

  const show = () => {
    globWindow.Intercom("show");
  };

  const hide = () => {
    globWindow.Intercom("hide");
  };

  const onShow = (cb: () => void) => {
    globWindow.Intercom("onShow", cb);
  };

  const onHide = (cb: () => void) => {
    globWindow.Intercom("onHide", cb);
  };

  const shutdown = () => {
    globWindow.Intercom("shutdown");
  };

  const trackEvent = (
    event: string,
    data?: { [key: string]: string | number | boolean }
  ) => {
    (globWindow.Intercom as any)("trackEvent", event, data);
  };

  const update = (data: {
    name?: string;
    facility?: string;
    email?: string;
    user_id?: string;
    [key: string]: any;
  }) => {
    (globWindow.Intercom as any)("update", data);
  };

  return { boot, shutdown, show, onShow, hide, onHide, update, trackEvent };
};
